import { IPropertyInfoMetadata } from "../../DotNet/SeriouslyRAD.Framework/Reflection/IPropertyInfoMetadata";
import { ITypeInfoMetadata } from "../../DotNet/SeriouslyRAD.Framework/Reflection/ITypeInfoMetadata";
import { EntityBaseProperties, IEntityBaseProperties } from "./BaseTypes/EntityBaseProperties";
import { ISoftDeletableEntityProperties, SoftDeletableEntityProperties } from "./BaseTypes/SoftDeletableEntityProperties";

export interface ITeamEntityPropertyPermissionProperties extends IEntityBaseProperties, ISoftDeletableEntityProperties
{

    // #region Basic Properties

    teamEntityPermissionId: IPropertyInfoMetadata;
    entityPropertyId: IPropertyInfoMetadata;
    permission: IPropertyInfoMetadata;

    // #endregion

    // #region Navigation Properties

    entityProperty: IPropertyInfoMetadata;
    teamEntityPermission: IPropertyInfoMetadata;

    // #endregion

}

export const TeamEntityPropertyPermission: ITypeInfoMetadata<ITeamEntityPropertyPermissionProperties> = {
    attributes: [
        {
            id: "{DE7DA71C-E0E4-4543-8467-15C197F8E6BC}",
            $type: "SeriouslyRAD.Framework.ClientAwareIdAttribute, SeriouslyRAD.Framework"
        },
        {
            name: "TeamEntityPropertyPermission",
            nameFriendly: "Team Entity Property Permission",
            namePlural: "TeamEntityPropertyPermissions",
            namePluralFriendly: "Team Entity Property Permissions",
            $type: "SeriouslyRAD.Framework.ClientAwareNameAttribute, SeriouslyRAD.Framework"
        }
    ],
    classHierarchy: [
        "SeriouslyRAD.Framework.Data.Entities.TeamEntityPropertyPermission, SeriouslyRAD.Framework.Data.Entities",
        "SeriouslyRAD.Framework.Data.EntityBase, SeriouslyRAD.Framework.Data.Entities",
        "System.Object, System.Private.CoreLib"
    ],
    hasEnumFlags: false,
    name: "TeamEntityPropertyPermission",
    properties: {
        ...EntityBaseProperties,
        ...SoftDeletableEntityProperties,
        teamEntityPermissionId: {
            attributes: [
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDisplayNameAttribute, SeriouslyRAD.Framework",
                    displayName: "Team Entity Permission"
                },
                {
                    entityDescriptionProperty: "Id",
                    entityName: "TeamEntityPermission",
                    entityNameFriendly: "Team Entity Permission",
                    entityNamePlural: "TeamEntityPermissions",
                    entityNamePluralFriendly: "Team Entity Permissions",
                    foreignEntityAlias: "TeamEntityPropertyPermissions",
                    $type: "SeriouslyRAD.Framework.Data.ClientAwareEntityIdAttribute, SeriouslyRAD.Framework.Data.Entities"
                },
                {
                    evaluator: {
                        $type: "SeriouslyRAD.Framework.Data.Evaluation.Evaluators.TrueEvaluator, SeriouslyRAD.Framework.Data.Entities"
                    },
                    $type: "SeriouslyRAD.Framework.ClientAwareMandatoryEvaluatorAttribute`1[[SeriouslyRAD.Framework.Data.Entities.TeamEntityPropertyPermission+TeamEntityPermissionIdMandatoryEvaluatorAttributeType, SeriouslyRAD.Framework.Data.Entities]], SeriouslyRAD.Framework"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareOrderAttribute, SeriouslyRAD.Framework",
                    order: 0
                },
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "TeamEntityPermissionId",
            propertyTypeId: "System.Nullable`1[[System.Guid, System.Private.CoreLib]], System.Private.CoreLib",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        entityPropertyId: {
            attributes: [
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDisplayNameAttribute, SeriouslyRAD.Framework",
                    displayName: "Entity Property"
                },
                {
                    entityDescriptionProperty: "Name",
                    entityName: "EntityProperty",
                    entityNameFriendly: "Entity Property",
                    entityNamePlural: "EntityProperties",
                    entityNamePluralFriendly: "Entity Properties",
                    foreignEntityAlias: "TeamEntityPropertyPermissions",
                    entityFilter: "entity/teamEntityPermissions/any(item1:item1/id eq [teamEntityPermissionId])",
                    $type: "SeriouslyRAD.Framework.Data.ClientAwareEntityIdAttribute, SeriouslyRAD.Framework.Data.Entities"
                },
                {
                    evaluator: {
                        $type: "SeriouslyRAD.Framework.Data.Evaluation.Evaluators.TrueEvaluator, SeriouslyRAD.Framework.Data.Entities"
                    },
                    $type: "SeriouslyRAD.Framework.ClientAwareMandatoryEvaluatorAttribute`1[[SeriouslyRAD.Framework.Data.Entities.TeamEntityPropertyPermission+EntityPropertyIdMandatoryEvaluatorAttributeType, SeriouslyRAD.Framework.Data.Entities]], SeriouslyRAD.Framework"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareOrderAttribute, SeriouslyRAD.Framework",
                    order: 1
                },
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "EntityPropertyId",
            propertyTypeId: "System.Nullable`1[[System.Guid, System.Private.CoreLib]], System.Private.CoreLib",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        permission: {
            attributes: [
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDisplayNameAttribute, SeriouslyRAD.Framework",
                    displayName: "Permission"
                },
                {
                    evaluator: {
                        $type: "SeriouslyRAD.Framework.Data.Evaluation.Evaluators.TrueEvaluator, SeriouslyRAD.Framework.Data.Entities"
                    },
                    $type: "SeriouslyRAD.Framework.ClientAwareMandatoryEvaluatorAttribute`1[[SeriouslyRAD.Framework.Data.Entities.TeamEntityPropertyPermission+PermissionMandatoryEvaluatorAttributeType, SeriouslyRAD.Framework.Data.Entities]], SeriouslyRAD.Framework"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareOrderAttribute, SeriouslyRAD.Framework",
                    order: 2
                },
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "Permission",
            propertyTypeId: "System.Nullable`1[[System.Int32, System.Private.CoreLib]], System.Private.CoreLib",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        entityProperty: {
            attributes: [
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "EntityProperty",
            propertyTypeId: "SeriouslyRAD.Framework.Data.Entities.EntityProperty, SeriouslyRAD.Framework.Data.Entities",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        teamEntityPermission: {
            attributes: [
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "TeamEntityPermission",
            propertyTypeId: "SeriouslyRAD.Framework.Data.Entities.TeamEntityPermission, SeriouslyRAD.Framework.Data.Entities",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        }
    },
    underlyingTypeId: "SeriouslyRAD.Framework.Data.Entities.TeamEntityPropertyPermission, SeriouslyRAD.Framework.Data.Entities",
    $type: "SeriouslyRAD.Framework.Reflection.TypeInfoMetadata, SeriouslyRAD.Framework"
};

